'use client';
import * as React from "react";
import { useDropdown_unstable } from "./useDropdown.js";
import { renderDropdown_unstable } from "./renderDropdown.js";
import { useDropdownStyles_unstable } from "./useDropdownStyles.styles.js";
import { useComboboxContextValues } from "../../contexts/useComboboxContextValues.js";
import { useCustomStyleHook_unstable } from "@fluentui/react-shared-contexts";
/**
 * Dropdown component: a selection control that allows users to choose from a set of possible options
 */ export const Dropdown = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useDropdown_unstable(props, ref);
    const contextValues = useComboboxContextValues(state);
    useDropdownStyles_unstable(state);
    useCustomStyleHook_unstable('useDropdownStyles_unstable')(state);
    return renderDropdown_unstable(state, contextValues);
});
Dropdown.displayName = 'Dropdown';
